import script from "./BeuInfoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeuInfoView.vue?vue&type=script&setup=true&lang=ts"

import "./BeuInfoView.vue?vue&type=style&index=0&id=6ee0f78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee0f78e"]])

export default __exports__